export const PaymentsHeadline = 'mb-4 text-black font-Roboto'

export const PaymentsListWrapper = 'flex flex-col'

export const PaymentItemWrapper =
  'flex flex-col border-gray94 border-b border-machine2-75 last-of-type:border-none'

export const PaymentSetAsDefaultActionButton =
  'hover:underline underline-offset-4 transition duration-200 order-first'

export const PaymentItemContentWrapper =
  'relative flex w-full flex-col p-4 transition duration-400 ease-in-out'

export const PaymentItemNewDefaultPaymentWrapper = 'bg-promotionBg'

export const PaymentPreferredPaymentLabel =
  'font-Roboto text-10 absolute right-4 bottom-4 sm:bottom-auto sm:top-4 rounded-md bg-black p-2 text-white uppercase'

export const PaymentRemoveDescription =
  'flex w-full pt-4 pb-2 text-black font-bold underline'

export const PaymentRemoveNote = 'flex w-full py-4 text-grayRegular text-12'

export const PaymentsConfirmBoxButtonsWrapper = 'flex w-full justify-end pt-4'
